import { Injectable } from "@angular/core";
import { doc, Firestore, setDoc } from "@angular/fire/firestore";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { map, switchMap, tap, withLatestFrom } from "rxjs/operators";
import { CryptoService } from "../../firebase/crypto.service";
import { AppState } from "../app.state";
import * as cryptoActions from "./crypto.actions";
import { CryptoWallet } from "./crypto.state";

@Injectable()
export class CryptoEffects {
    constructor(
        private actions$: Actions,
        private store: Store<AppState>,
        private cryptoService: CryptoService,
        private firestore: Firestore,
    ){}

    loadNftAssets$ = createEffect(() => 
        this.actions$.pipe(
            ofType(cryptoActions.loadNftAssets),
            map(() => {
                this.cryptoService.subscribeToNftAssets();
                this.cryptoService.dispatchCheckOwnedNft();
            })
        ),
        {
            dispatch: false
        }
    )

    connectWallet$ = createEffect(() =>
        this.actions$.pipe(
            ofType(cryptoActions.connectWallet),
            withLatestFrom(this.store.select('auth')),
            switchMap(([action, state]) => {
                const wallet = action.chain === 'ethereum' ? 'metamask' : 'phantom';
                const address = action.chain === 'ethereum' ? action.address.toLowerCase() : action.address;
                return setDoc(
                    doc(this.firestore, `users/${ state.userID }/wallets/${ wallet }`),
                    {
                        address,
                        chainId: action.chainId,
                        provider: action.provider,
                        chain: action.chain,
                        session: action.session,
                        connectedAt: action.connectedAt,
                    }
                )
            })
        ),
        { dispatch: false }
    );

    disconnectWallet$ = createEffect(() =>
        this.actions$.pipe(
            ofType(cryptoActions.disconnectWallet),
            withLatestFrom(this.store.select('auth')),
            tap(() => this.cryptoService.unsubscribeFromNftAssets()),
            switchMap(([action, state]) => {
                const nullData: CryptoWallet = {
                    address: null,
                    chainId: null,
                    provider: null,
                    chain: null,
                    session: null,
                    connectedAt: null,
                };

                const wallet = action.chain === 'ethereum' ? 'metamask' : 'phantom';
                return setDoc(doc(this.firestore, `users/${state.userID}/wallets/${ wallet }`), nullData);
            }),
            withLatestFrom(this.store.select('auth')),
            tap(([_, auth]) => this.cryptoService.checkOwnership(auth.userID as string))
        ),
        { dispatch: false }
    );
}
